import React, { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { IPagamento } from "core/interfaces/data/IAssistitoRequest";
import { ICheckoutFormProps } from "components/CheckoutForm/ICheckoutFormProps";
import { PaymentMode } from "types/PaymentMode";
import { Enhanced } from "utils/ReactUtils";

export const CheckoutForm: React.FC<ICheckoutFormProps> = ({ clientSecret, onSubmit,t }) => {
	const stripe = useStripe();
	const elements = useElements();
	const [message, setMessage] = useState<string | null | undefined>(null);
	const [isLoading, setIsLoading] = useState(true);

	const handleSubmit = async (e: any) => {
		e.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}

		stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
			if (!paymentIntent) return;
		});

		setIsLoading(true);

		const { paymentIntent, error } = await stripe.confirmPayment({
			elements,

			confirmParams: {
				return_url: `${window.location.origin}/ReservedArea`,
			},
			redirect: "if_required",
		});
		if (paymentIntent !== undefined)
			switch (paymentIntent.status) {
				case "succeeded":
					const a: IPagamento = { TransactionID: paymentIntent.id, Success: true, Skipped: false, TipoPagamento: PaymentMode.CartaDiCredito };
					onSubmit(a);
					//setMessage("Pagamento riuscito");
					break;
				case "processing":
					setMessage("Your payment is processing.");
					break;
			}

		if (error === undefined) return;
		setIsLoading(false);
		if (error.type === "card_error" || error.type === "validation_error") {
			setMessage(error.message);
		} else {
			setMessage("An unexpected error occurred.");
		}
	};

	return (
		<form id="payment-form" className="payment-form" onSubmit={handleSubmit}>
			<PaymentElement
				id="payment-element"
				onReady={() => {
					setIsLoading(false);
				}}
			/>
			<button className="payment-button" disabled={isLoading || !stripe || !elements} id="submit">
				<span id="button-text">{isLoading ? <div className="spinner" id="spinner"></div> : t("pagamento.buttonPay")}</span>
			</button>
			{/* Show any error or success messages */}
			{message && <div id="payment-message">{message}</div>}
		</form>
	);
};
export default Enhanced( CheckoutForm,{componentNamespace:"CheckoutForm"});
